import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import IconPlus from 'components/icons/iconPlus';
import Currency from 'components/consumer/Currency';
import Placeholder from 'components/consumer/Placeholder';
import ProtectionPlanButtonAndModal from 'components/consumer/ProtectionPlanButtonAndModal';
import ProtectionPlanModal from 'components/consumer/ProtectionPlanModal';
import { PRODUCT_CONFIGURATION_INTERACTION, trackProductConfigurationInteracted } from 'data-hooks/useEvents/pdpInteractionEvents';
import PDPProtectionPlanSelectorPlaceholder from './PDPProtectionPlanSelectorPlaceholder';
import usePdpSelectedProtectionPlanId from '../state/pdpSelectedProtectionPlanId/usePdpSelectedProtectionPlanId';
import useResetPdpSelectedProtectionPlanId from '../state/pdpSelectedProtectionPlanId/useResetPdpSelectedProtectionPlanId';
const PDPProtectionPlanSelectorUI = t0 => {
  const $ = _c(36);
  const {
    allProtectionPlanTypes,
    loading,
    meta,
    onProtectionPlanSelection,
    isLayoutRevamp: t1
  } = t0;
  const isLayoutRevamp = t1 === undefined ? false : t1;
  const [isProtectionModalOpen, setIsProtectionModalOpen] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsProtectionModalOpen(true);
      trackProductConfigurationInteracted(PRODUCT_CONFIGURATION_INTERACTION.PROTECTION_PLAN_OPENED);
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const openProtectionModal = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setIsProtectionModalOpen(false);
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const closeProtectionModal = t3;
  const pdpSelectedProtectionPlanId = usePdpSelectedProtectionPlanId();
  const resetPdpSelectedProtectionPlanId = useResetPdpSelectedProtectionPlanId();
  let t4;
  if ($[2] !== resetPdpSelectedProtectionPlanId) {
    t4 = () => {
      resetPdpSelectedProtectionPlanId();
      trackProductConfigurationInteracted(PRODUCT_CONFIGURATION_INTERACTION.PROTECTION_PLAN_REMOVED);
    };
    $[2] = resetPdpSelectedProtectionPlanId;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const removeProtectionPlan = t4;
  const revampRowRef = useRef(null);
  if (loading && isLayoutRevamp) {
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <PDPProtectionPlanSelectorPlaceholder isLayoutRevamp={true} />;
      $[4] = t5;
    } else {
      t5 = $[4];
    }
    return t5;
  }
  if (loading) {
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="min-h-[66px] mt-8 mx-0 mb-0 w-full"><Placeholder type="rect" loading={true} style={{
          height: "52px"
        }} /></div>;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    return t5;
  }
  let t5;
  if ($[6] !== allProtectionPlanTypes || $[7] !== pdpSelectedProtectionPlanId) {
    t5 = pdpSelectedProtectionPlanId ? allProtectionPlanTypes.filter(singlePlan => singlePlan.plan_id === pdpSelectedProtectionPlanId)?.[0] : null;
    $[6] = allProtectionPlanTypes;
    $[7] = pdpSelectedProtectionPlanId;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const selectedProtectionPlan = t5;
  let t6;
  if ($[9] !== allProtectionPlanTypes || $[10] !== meta?.eligible_protection_planids) {
    t6 = allProtectionPlanTypes ? allProtectionPlanTypes.filter(singlePlan_0 => meta?.eligible_protection_planids.includes(singlePlan_0.plan_id)) : [];
    $[9] = allProtectionPlanTypes;
    $[10] = meta?.eligible_protection_planids;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const eligible_plans = t6;
  let t7;
  if ($[12] !== eligible_plans || $[13] !== isProtectionModalOpen || $[14] !== onProtectionPlanSelection || $[15] !== removeProtectionPlan || $[16] !== selectedProtectionPlan) {
    t7 = <ProtectionPlanButtonAndModal close={closeProtectionModal} eligible_plans={eligible_plans} forPage="PDP" isOpen={isProtectionModalOpen} onSelect={onProtectionPlanSelection} openModal={openProtectionModal} removeProtectionPlan={removeProtectionPlan} selectedProtectionPlan={selectedProtectionPlan} />;
    $[12] = eligible_plans;
    $[13] = isProtectionModalOpen;
    $[14] = onProtectionPlanSelection;
    $[15] = removeProtectionPlan;
    $[16] = selectedProtectionPlan;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const protectionPlanButtonAndModal = t7;
  if (isLayoutRevamp) {
    let t8;
    if ($[18] !== eligible_plans || $[19] !== isProtectionModalOpen || $[20] !== onProtectionPlanSelection || $[21] !== selectedProtectionPlan) {
      t8 = <ProtectionPlanModal buttonRef={revampRowRef} close={closeProtectionModal} eligiblePlans={eligible_plans} forPage="PDP" isOpen={isProtectionModalOpen} onSelect={onProtectionPlanSelection} selectedPlan={selectedProtectionPlan} />;
      $[18] = eligible_plans;
      $[19] = isProtectionModalOpen;
      $[20] = onProtectionPlanSelection;
      $[21] = selectedProtectionPlan;
      $[22] = t8;
    } else {
      t8 = $[22];
    }
    const t9 = selectedProtectionPlan ? undefined : "dialog";
    const t10 = selectedProtectionPlan ? `Remove ${selectedProtectionPlan.plan_name}` : undefined;
    const t11 = selectedProtectionPlan ? removeProtectionPlan : openProtectionModal;
    let t12;
    if ($[23] !== selectedProtectionPlan) {
      t12 = selectedProtectionPlan ? <><span className="min-w-0 break-words">5-year {selectedProtectionPlan.plan_name} (+<Currency>{selectedProtectionPlan.plan_price}</Currency>)</span><span className="flex-none text-xs text-brand hover:underline">Remove</span></> : <>Add Protection<IconPlus aria-hidden="true" height="12" width="12" /></>;
      $[23] = selectedProtectionPlan;
      $[24] = t12;
    } else {
      t12 = $[24];
    }
    let t13;
    if ($[25] !== t10 || $[26] !== t11 || $[27] !== t12 || $[28] !== t9) {
      t13 = <button ref={revampRowRef} type="button" aria-haspopup={t9} aria-label={t10} className="flex items-center justify-between gap-2 w-full min-h-[3rem] p-3 bg-transparent border-0 cursor-pointer text-left text-base font-bold text-gray focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand focus-visible:-outline-offset-2" onClick={t11}>{t12}</button>;
      $[25] = t10;
      $[26] = t11;
      $[27] = t12;
      $[28] = t9;
      $[29] = t13;
    } else {
      t13 = $[29];
    }
    let t14;
    if ($[30] !== t13 || $[31] !== t8) {
      t14 = <div className="mt-8 w-full rounded border border-solid border-gray-light6 hover:border-gray-light2" data-xc="PDPProtectionPlanRow">{t8}{t13}</div>;
      $[30] = t13;
      $[31] = t8;
      $[32] = t14;
    } else {
      t14 = $[32];
    }
    return t14;
  }
  let t8;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <h3 className="text-base font-bold mt-0 mx-0 mb-1.5">Protect Your Investment</h3>;
    $[33] = t8;
  } else {
    t8 = $[33];
  }
  let t9;
  if ($[34] !== protectionPlanButtonAndModal) {
    t9 = <div className="min-h-[66px] mt-8 mx-0 mb-0 w-full">{t8}{protectionPlanButtonAndModal}</div>;
    $[34] = protectionPlanButtonAndModal;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  return t9;
};
PDPProtectionPlanSelectorUI.propTypes = {
  allProtectionPlanTypes: PropTypes.array,
  loading: PropTypes.bool,
  meta: PropTypes.object,
  onProtectionPlanSelection: PropTypes.func,
  isLayoutRevamp: PropTypes.bool
};
export default PDPProtectionPlanSelectorUI;